<template lang="pug">
  svg(viewBox="0 0 270 320" xmlns="http://www.w3.org/2000/svg")
    g(v-for="(g, i) in svg" :key="`svg_g_${i}`" :class="`g_${i}`")
      path(stroke="currentColor" stroke-width="2" fill="none" :d="g.p")
      g(fill="currentColor"): circle(v-for="(c, j) in g.c" :key="`svg_c_${i}_${j}`" :cx="c[0]" :cy="c[1]" r="3.5")
    rect(stroke="currentColor" fill="none" x="106" y="121" width="58" height="58" rx="6" stroke-width="3")
    rect(fill="inherit" x="112" y="127" width="46" height="46" rx="4")
    path(fill="#fff" fill-rule="evenodd" clip-rule="evenodd" d="M136.988 159.917C139.724 159.917 142.202 158.807 143.995 157.012L149 162.021C145.926 165.097 141.679 167 136.988 167C133.838 167 130.888 166.142 128.36 164.647L120 167L122.351 158.634C120.857 156.104 120 153.152 120 150C120 140.611 127.606 133 136.988 133C141.679 133 145.926 134.903 149 137.979L143.995 142.988C142.202 141.193 139.724 140.083 136.988 140.083C131.515 140.083 127.078 144.523 127.078 150C127.078 155.477 131.515 159.917 136.988 159.917Z")
</template>

<script>
export default {
  name: 'TheBrain',
  // Data ----------------------------------------------------------------------
  data () {
    return {
      svg: [
        {
          p: 'M137 121V83M106 158H60L47 145M164 176L186 197V217M63 113V93L76 80H95M212 248L218 242V222M182 85H199L228 114V140',
          c: [[137, 83], [47, 145], [186, 217], [218, 222], [63, 113], [95, 80], [182, 85], [228, 140], [212, 248]]
        },
        {
          p: 'M164 140H184L194 130V107L188 101M106 145H80L57 122H42M145 179V198L134 210M94 174L83 185V206L94 217H108M222 183H239L247 175V149L239 141',
          c: [[94, 174], [108, 217], [134, 210], [188, 101], [42, 122], [239, 141], [222, 183]]
        },
        {
          p: 'M164 165H173L183 154H232M34 155V177L48 191H62L69 198M88 101L117 72H158L172 86V113M210 212H223L233 202V193M160 192V209L147 222H127L106 201',
          c: [[106, 201], [160, 192], [210, 212], [232, 154], [34, 155], [69, 198], [88, 101], [172, 113], [233, 193]]
        },
        {
          p: 'M207 261L200 254V197L192 189M111 179L95 195V204M80 94L74 100V116L88 130M151 121V97L158 90M200 144H208L214 138V118M74 175H58L46 163',
          c: [[200, 144], [214, 118], [192, 189], [207, 261], [95, 204], [74, 175], [46, 163], [80, 94], [88, 130], [158, 90]]
        },
        {
          p: 'M23 162V143L31 135H57M128 179V191L122 198M127 121L119 113V92M184 174L193 165H226L233 172',
          c: [[233, 172], [184, 174], [122, 198], [119, 92], [57, 135], [23, 162]]
        },
        {
          p: 'M171 203V223L185 237H191M201 178L218 195M108 123L97 112M27 128V117L38 106H52',
          c: [[52, 106], [97, 112], [171, 203], [191, 237], [201, 178], [218, 195], [27, 128]]
        }
      ]
    }
  }
}
</script>
